import React from 'react';
import Test from './Test';
import TestCreator from './TestCreator';
import axios from 'axios';
import TestProtocol from './TestProtocol';

import * as Globals from './../Globals';


export default class CourseView extends React.Component {

    constructor(props) {
        super(props);

        this.testDate = "";
        this.testName = "";
        this.mark = "";
        this.id = this.props.id;
        this.simulation = false;
        this.state = {
            course: "",
            testIDs: [],
            createTest: false,
            viewProtocolID: -1
        }
    }

    componentDidMount() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.BASE_PATH + 'api/courses/' + this.id,
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookie
                }
            }).then(response => {
            this.setState({
                course: response.data
            });
        }).catch(error => {
            this.props.CheckAuthError(error);
        });
        this.updateTests();
    }

    updateTests() {
        let cookie = this.props.LogoutOnCookieNotSet();
        axios.get(Globals.EL_PATH + 'course/' + this.id + '/test?Authentication=' + cookie)
            .then(response => {
                let testIDs = [];
                response.data.records.forEach((test) => testIDs.push(test.id));
                this.setState({
                    testIDs: testIDs
                });
            })
            .catch(error => {
                this.props.CheckAuthError(error);
            });
    }

    handleCloseCreator(refresh) {
        if (refresh) {
            this.updateTests();
        }
        this.setState({
            createTest: false
        });
    }

    handleViewProtocol(id, date, name, mark) {
        this.testDate = date;
        this.testName = name;
        this.mark = mark;
        this.setState({
            viewProtocolID: id
        });
    }

    handleTestsRequest() {
        this.testDate = "";
        this.testName = "";
        this.mark = "";
        this.setState({
            viewProtocolID: -1
        });
    }

    getRenderBlock() {
        if (this.state.createTest) {
            return (
                <div className="container courseTestCreator">
                    <h1 className="text-center">{(this.state.course !== "") ? this.state.course.id : ""}</h1>
                    <TestCreator CheckAuthError={this.props.CheckAuthError}
                                 LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} courseID={this.props.id}
                                 sendCloseCreator={this.handleCloseCreator.bind(this)}/>
                </div>
            );
        }
        if (this.state.viewProtocolID > -1) {
            return (
                <div className="container-flex test-protocol">
                    <h3 className="text-center">{this.state.course.id}</h3>
                    <h4 className="text-center">{this.testDate} - Testprotokoll</h4>
                    <TestProtocol CheckAuthError={this.props.CheckAuthError}
                                  LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet} id={this.state.viewProtocolID}
                                  name={this.testName} mark={this.mark}
                                  sendTestsRequest={this.handleTestsRequest.bind(this)}/>
                </div>
            );
        }
        return (
            <div className="container-flex course">
                <h2 className="text-center">
                    <b>
                        {(this.state.course !== "") ? this.state.course.id : ''}
                    </b>
                    {(this.state.course !== "") ? ' - ' + this.state.course['course-topic'].name : ""}</h2>
                <button className="btn btn-info center-block" type="button"
                        onClick={() => this.setState({createTest: true})}>Test generieren
                </button>
                <div className="panel panel-default course-tests">
                    <div className="panel-heading text-center"><h2>Tests</h2></div>
                    {(this.state.testIDs.length === 0) ?
                        <p className="text-center" style={{margin: '10px 10px'}}>Keine Tests vorhanden...</p> : null}
                    <ul className="list-group">
                        {
                            this.state.testIDs.map((id) => {
                                return (
                                    <Test key={id} CheckAuthError={this.props.CheckAuthError}
                                          LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet}
                                          handleViewProtocol={this.handleViewProtocol.bind(this)} id={id}/>
                                );
                            })
                        }
                    </ul>
                </div>
                <button className="btn btn-danger center-block" type="button"
                        onClick={() => this.props.sendCourseListRequest()}>Zur Kursübersicht
                </button>
            </div>
        );
    }

    render() {
        return (this.getRenderBlock());
    }

}



// WEBPACK FOOTER //
// ./src/admin/CourseView.js